import axios from '@/libs/api.request'

// 获取配置
export const apiContactList = (data) => {
  return axios.request({
    url: `/clue`,
    method:'get',
    data
  })
}

// 更新配置
export const apiContactDelete = (id,data) => {
  return axios.request({
    url: `/clue/${id}`,
    method:'delete',
    data
  })
}

// 跟进
export const apiContactPut = (id, data) => {
	return axios.request({
		url: `/clue/${id}`,
		method: 'put',
		data,
	})
}